// extracted by mini-css-extract-plugin
export var label = "_rl-0";
export var link = "_rl-1";